// Editable landing-page constants. Fill the TODOs before the real launch.

// WhatsApp contact, digits only with country code (used in a wa.me link).
export const WHATSAPP_NUMBER = '62'; // TODO: real number, e.g. 628123456789

// Contact email (used in a mailto link).
export const CONTACT_EMAIL = 'halo@livinhome.id'; // TODO: real address

// When the resident app ships (Phase B), set this to the Play Store URL. While it
// stays null, the download CTA renders as a disabled "Segera hadir" badge.
export const PLAY_STORE_URL: string | null = null;
